<app-loader *ngIf="isDisabled"></app-loader>
<div class="card mt-2 border-radius-0 p-1">
    <div class="card-header">
        <div class="row">
            {{this.Filter.TravelType}} Expense History
        </div>

    </div>
    <div class="card-body p-0">
        <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row pb-3">
                <div class="col-md-3">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status" name="ApprovalStatus"
                        [(ngModel)]="Filter.ApprovalStatus" #ApprovalStatus="ngModel" (change)="Clear()"  required>
                        <option value="All">All</option>
                        <option value="Approved">Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Corrected">Corrected</option>
                        <option value="Reimbursed">Reimbursed</option>
                        <option value="Reimburse Pending">Reimburse Pending</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label for="FromDateObj" class="form-font-label"><span class="text-danger">*</span>From
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                            readonly (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDateObj" class="form-font-label"><span class="text-danger">*</span>To
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required readonly
                            (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-auto mt-4  pt-1"><button class="btn btn-primary" [disabled]="isDisabled"><i
                            class="bi bi-cloud-download me-2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}</button></div>
            </div>
        </form>

        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th>Report Name</th>
                        <th style="width: 5px;">Request Date</th>
                        <th style="width: 5px;">Reimbursed</th>
                        <th style="width: 5px;">Requested Amount</th>
                        <th style="width: 5px;">Reimbursed Amount</th>
                        <th style="width: 5px;">Status</th>
                        <th style="width: 5px;">View</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 120px;">
                            <div style="width: 120px;">{{TableData['ReportName']}}</div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['RequestDate'] | date: 'dd MMM yyyy'}}</div>
                        </td>
                        <td style="width: 5px;text-align:end">
                            <div style="width: 50px;">{{TableData['IsReimbursed']?'Yes':'No'}}</div>
                        </td>
                        <td><span style="float: inline-end;">{{TableData['ReimbursedRequestedAmount']}}</span></td>
                        <td><span style="float: inline-end;">{{TableData['ReimbursedApprovedAmount']}}</span></td>
                        <td style="width: 5px;">
                            <span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">
                                {{TableData['ApprovalStatus']}}</span>
                        </td>
                        <td style="width: 5px;text-align: -webkit-center;">
                            <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    [routerLink]="['/request/'  + (this.common.ToLowerCase(this.Filter.TravelType) == 'local'?'expense':this.common.ToLowerCase(this.Filter.TravelType) == 'outstation'?'outstation':'') + '/detail/',TableData['ESS_ExpenseReportRequestId']]" ><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                    class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
        </div>
    </div>
</div>